// eslint-disable-next-line import/prefer-default-export
export const GET_REVIEWS = 'GET_REVIEWS';
